import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import { bookingShape } from 'constants/propTypes';

import BookingPathPassengerDetails from 'pages/BookingPathPassengerDetails';
import PaymentBookingPath from 'pages/PaymentBookingPath';
import GroupDetails from 'pages/GroupDetails';
import AddAssistance from 'pages/AddAssistance';
import BookingPathReviewBooking from 'pages/BookingPathReviewBooking';
import BookingMagnetMultiJourney from 'pages/BookingMagnetMultiJourney';
import JourneySearch from 'pages/JourneySearchMultiJourney';

const BookingPathRoutes = ({ booking, canAddSpecialAssistanceToBooking }) => (
  <Switch>
    <Route
      exact
      path="/booking/:reference/pax"
      component={() => (
        <BookingPathPassengerDetails bookingData={booking} canAddSpecialAssistanceToBooking={canAddSpecialAssistanceToBooking} />
      )}
    />
    <Route exact path="/booking/:reference/pax/assistance" component={() => <AddAssistance bookingData={booking} />} />
    <Route
      exact
      path="/booking/:reference/group"
      component={() => <GroupDetails bookingData={booking} canAddSpecialAssistanceToBooking={canAddSpecialAssistanceToBooking} />}
    />
    <Route exact path="/booking/:reference/review-booking" component={BookingPathReviewBooking} />
    <Route exact path="/booking/:reference/search" component={BookingMagnetMultiJourney} />
    <Route exact path="/booking/:reference/journeys" component={JourneySearch} />
    <Route path="/booking/:reference/payment" component={() => <PaymentBookingPath bookingData={booking} />} />
  </Switch>
);

BookingPathRoutes.propTypes = {
  booking: bookingShape,
  canAddSpecialAssistanceToBooking: PropTypes.bool.isRequired
};

export default BookingPathRoutes;
